var _defs, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFewCloudsNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efcc00;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(-1, 0, 0, 1, 65.97, 0)",
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient",
    x1: 46.72,
    x2: 25.63,
    y1: 58.39,
    y2: 31.08
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0, -1, -1, 0, 168.93, 51.25)",
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient-2",
    x1: 4.06,
    x2: 15.68,
    y1: 116.66,
    y2: 134.3
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,26.71A13.88,13.88,0,0,1,37.86,8.77.6.6,0,0,0,37,8.08,13.88,13.88,0,1,0,55.92,27a.6.6,0,0,0-.69-.89A13.91,13.91,0,0,1,50,26.71Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.66,21.9a17.49,17.49,0,0,1,15.47,9.32A13.75,13.75,0,1,1,46,56.84l-22.39.06a17.5,17.5,0,0,1,0-35Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 46.05,
    cy: 43.09,
    r: 13.75,
    transform: "translate(-7.84 75.85) rotate(-74.39)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFewCloudsNight);
export default __webpack_public_path__ + "static/media/few_clouds_night.dde309547bea61e5c31791e5b6433726.svg";
export { ForwardRef as ReactComponent };